import { getConfig } from "./env";

// Lazy getters that only call getConfig when accessed
export const BASE_URL = () => getConfig().VITE_APP_BASE_URL;
export const PUSHER_API_KEY = () => getConfig().VITE_APP_PUSHER_API_KEY;
export const PUSHER_CLUSTER = () => getConfig().VITE_APP_PUSHER_CLUSTER;

// Alternative: You can also create cached versions
let _baseUrl: string | null = null;
let _pusherApiKey: string | null = null;
let _pusherCluster: string | null = null;

export const getCachedBaseUrl = () => {
  if (_baseUrl === null) _baseUrl = getConfig().VITE_APP_BASE_URL;
  return _baseUrl;
};

export const getCachedPusherApiKey = () => {
  if (_pusherApiKey === null)
    _pusherApiKey = getConfig().VITE_APP_PUSHER_API_KEY;
  return _pusherApiKey;
};

export const getCachedPusherCluster = () => {
  if (_pusherCluster === null)
    _pusherCluster = getConfig().VITE_APP_PUSHER_CLUSTER;
  return _pusherCluster;
};
